import {Banner} from '@primer/react'

export type StackCreatedInfo = {
  stackNumber: number
  appended: boolean
}

export type StackCreatedBannerProps = {
  info: StackCreatedInfo
  onDismiss: () => void
}

export function StackCreatedBanner({info, onDismiss}: StackCreatedBannerProps) {
  const bannerText = info.appended
    ? `This pull request was added to stack #${info.stackNumber}`
    : `Stack #${info.stackNumber} was created successfully`

  return (
    <Banner
      aria-label={bannerText}
      title={bannerText}
      hideTitle
      description={bannerText}
      variant="success"
      onDismiss={onDismiss}
    />
  )
}
